import React from 'react';

export const CheckIcon = (props: React.SVGProps<SVGSVGElement>) => (
	<svg fill="none" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			d="M13.945 5.59417L9.0075 12.295L5.86833 9.78333C5.41167 9.43333 4.75667 9.52 4.40667 9.97667C4.06667 10.42 4.1375 11.0525 4.56583 11.4108L8.55167 14.5992C9.00917 14.9575 9.67083 14.8767 10.0292 14.4183C10.0333 14.4133 10.0367 14.4083 10.0408 14.4033L15.6242 6.83083C15.9642 6.36667 15.8642 5.715 15.4 5.37417C14.9375 5.03333 14.2858 5.13167 13.945 5.59417ZM10 0C4.4775 0 0 4.4775 0 10C0 15.5225 4.4775 20 10 20C15.5225 20 20 15.5225 20 10C19.9942 4.48 15.52 0.00583333 10 0ZM10 18.3333C5.3975 18.3333 1.66667 14.6025 1.66667 10C1.66667 5.3975 5.3975 1.66667 10 1.66667C14.6025 1.66667 18.3333 5.3975 18.3333 10C18.3283 14.6 14.6 18.3283 10 18.3333Z"
			fill="currentColor"
		/>
	</svg>
);
